export const BASE_CLASS = 'mt-TechnicalDetailsVehicle'
export const MODEL_DETAILS_CLASS = `${BASE_CLASS}-modelDetails`
export const MODEL_DETAILS_INFO_CLASS = `${MODEL_DETAILS_CLASS}-info`
export const PANEL_EQUIPMENT_CLASS = `${BASE_CLASS}-panelEquipment`
export const PANEL_EQUIPMENT_INFO_CLASS = `${PANEL_EQUIPMENT_CLASS}-info`
export const SCROLL_PARAMS = {block: 'center', behavior: 'smooth'}
export const BEST_OFFERS_SECTION_ELEMENT_ID = 'best-offers-id'
export const SPACE_STRING = ' '
export const LOW_DASH = '_'
export const MAX_NUM_OF_ADS = 4
